// Shared QC-polling loop for the Sources page. Both `openQc` and
// `rerunQc` had identical 25-line poll-until-done bodies that
// would drift if one got fixed and the other didn't.
//
// `pollQcReport` polls `/api/jobs/available-files/{filename}/qc`
// every `intervalMs` (default 5s) until either:
//   - the report comes back with `running === false` (returns the
//     final data object)
//   - `maxWaitMs` elapses (returns null, calls `onTimeout`)
//
// Per-tick state — useful for progressive drawer updates while
// the backend is still chewing — surfaces via `onTick(data)`.
export const QC_POLL_DEFAULT_INTERVAL_MS = 5000;
export const QC_POLL_DEFAULT_MAX_WAIT_MS = 15 * 60 * 1000;

export async function pollQcReport(api, filename, options = {}) {
  const {
    onTick,
    onTimeout,
    intervalMs = QC_POLL_DEFAULT_INTERVAL_MS,
    maxWaitMs = QC_POLL_DEFAULT_MAX_WAIT_MS,
    now = () => Date.now(),
    sleep = (ms) => new Promise((r) => setTimeout(r, ms)),
  } = options;

  const startedAt = now();
  while (now() - startedAt < maxWaitMs) {
    await sleep(intervalMs);
    try {
      const url = `/api/jobs/available-files/${encodeURIComponent(filename)}/qc`;
      const { data } = await api.get(url);
      if (data && data.running === false) {
        return data;
      }
      if (onTick) {
        try { onTick(data); } catch (_e) { /* swallow consumer errors */ }
      }
    } catch (_e) {
      // Network blip / transient — keep polling. Real failure is
      // surfaced via the timeout path.
    }
  }
  if (onTimeout) {
    try { onTimeout(); } catch (_e) { /* swallow */ }
  }
  return null;
}
